import AppMainInfo from "./app-main-info";

export default AppMainInfo